<template>
	<div>
		<div class="driver-info shadowed">
			<div class="driver-info-head">
				<div class="row">
					<div class="col-xs-12 driver-info-name" title="Motorista da rota">
						{{ (driver.driver_name ? driver.driver_name : driver.name) + " (" + driver.nickname + ")" }}
					</div>
					<div class="col-xs-12 col-lg-3 driver-info-summary" title="Veículo utilizado na rota">
						<div class="driver-info-summary-icon"><i class="fa fa-fw fa-truck"></i></div>
						<div class="driver-info-summary-label">{{ driver.current_license_plate ? driver.current_license_plate : "Não definido"}}</div>
					</div>
					<div class="col-xs-12 col-lg-3 driver-info-summary" title="Carga da rota">
						<div class="driver-info-summary-icon"><i class="fa fa-fw fa-boxes"></i></div>
						<div class="driver-info-summary-label">{{ driver.current_cargo ? driver.current_cargo : "Não definido" }}</div>
					</div>
					<div class="col-xs-12 col-lg-3 driver-info-summary" title="Peso total">
						<div class="driver-info-summary-icon"><i class="fas fa-fw fa-weight-hanging"></i></div>
						<div class="driver-info-summary-label">{{ getWeight(total_weight) }}</div>
					</div>
					<div class="col-xs-12 col-lg-3 driver-info-summary" title="Distância total da rota">
						<div class="driver-info-summary-icon"><i class="fa fa-fw fa-road"></i></div>
						<div class="driver-info-summary-label">{{ total_distance.toFixed(2).replace(".", ",") }} km</div>
					</div>
				</div>
			</div>
			<div class="driver-info-form">
				<div class="row">
					<div class="col-xs-6 input-pause-label">Permanência maior que (min):</div>
					<div class="col-xs-4 input-pause-div">
						<span class="input-label"><i class="fas fa-dot-circle"></i></span>
						<input class="filter input-pause" type="number" v-model="pause" @keydown.enter.prevent="updatePause();showMessage();" />
						<button class="input-clean" title="Limpar tempo" @click="inputPauseClean();"><i class="fas fa-times"></i></button>
					</div>
					<div class="col-xs-2">
						<button class="button-edit input-pause-button" title="Exibir permanência" @click="updatePause();showMessage();">OK</button>
					</div>
				</div>
			</div>
			<div class="driver-info-list">
				<br/>
				<button class="driver-info-body-tab" :class="{ 'enabled': (tab == 'delivery') }" @click="tab = 'delivery'">
					Entregas ({{ (deliveries ? deliveries.length : 0) }})
				</button>
				<button class="driver-info-body-tab" :class="{ 'enabled': (tab == 'circle') }" @click="tab = 'circle'">
					<small>Regiões de maior permanência</small> ({{ (circle_list ? circle_list.length : 0) }})
				</button>
			</div>
			<div class="driver-info-body driver-info-body-tab-block" :class="{ 'show': (tab == 'delivery') }">
				<div v-for="(delivery, index) in deliveries" :key="index" class="driver-item" @click="onClick(delivery.coordinates)">
					<div class="driver-info-item">
						<div class="driver-info-left">Número</div>
						<div class="driver-info-right">{{ delivery.document_number }}</div>
					</div>
					<div class="driver-info-item">
						<div class="driver-info-left">Data de entrega</div>
						<div class="driver-info-right">{{ getDateFormated(delivery.date) }}</div>
					</div>
					<div class="driver-info-item">
						<div class="driver-info-left">Situação</div>
						<div class="driver-info-right capitalized"><span :style="'color: ' + getStatusColor(delivery.status)"><i class="fa fa-fw fa-circle"></i></span> {{ getStatus(delivery.status) }}</div>
					</div>
					<div v-if="deliveries.length > 1" class="driver-info-item">
						<div class="driver-info-left">Sequência prevista</div>
						<div class="driver-info-right">{{ delivery.sequence }}</div>
					</div>
					<div v-if="deliveries.length > 1" class="driver-info-item">
						<div class="driver-info-left">Sequência de entrega</div>
						<div class="driver-info-right">{{ (delivery.status == "finished" || delivery.status == "failed" ? index + 1 : "-") }}</div>
					</div>
					<div class="driver-info-item">
						<div class="driver-info-left">Cliente</div>
						<div class="driver-info-right capitalized">{{ delivery.customer_name ? delivery.customer_name.toLowerCase() : "-" }}</div>
					</div>
					<div class="driver-info-item">
						<div class="driver-info-left">Endereço</div>
						<div class="driver-info-right capitalized">{{ delivery.fk_address ? delivery.street.toLowerCase() + ", " + delivery.number.toLowerCase() + " - " + delivery.neighborhood.toLowerCase() + ", " + delivery.city.toLowerCase() + " - " + delivery.uf.toUpperCase() + ", " + delivery.postal_code.replace(/^(\d{5})(\d{3})/, "$1-$2") : "-" }}</div>
					</div>
					<div class="driver-info-item">
						<div class="driver-info-left">Peso</div>
						<div class="driver-info-right">{{ getWeight(delivery.weight) }}</div>
					</div>
					<div class="driver-info-item">
						<div class="driver-info-left">Qtd. Itens</div>
						<div class="driver-info-right">{{ delivery.quantity }} unid.</div>
					</div>
					<div class="driver-info-item">
						<div class="driver-info-left">Início da entrega</div>
						<div class="driver-info-right">{{ delivery.delivery_start ? getDateAndHourFormated(delivery.delivery_start) : "-" }}</div>
					</div>
					<div class="driver-info-item">
						<div class="driver-info-left">Pausa da entrega</div>
						<div class="driver-info-right">{{ delivery.delivery_pause ? getDateAndHourFormated(delivery.delivery_pause) : "-" }}</div>
					</div>
					<div class="driver-info-item">
						<div class="driver-info-left">Reinício da entrega</div>
						<div class="driver-info-right">{{ delivery.delivery_restart ? getDateAndHourFormated(delivery.delivery_restart) : "-" }}</div>
					</div>
					<div class="driver-info-item">
						<div class="driver-info-left">Fim da entrega</div>
						<div class="driver-info-right">{{ delivery.delivery_end ? getDateAndHourFormated(delivery.delivery_end) : "-" }}</div>
					</div>
				</div>
			</div>
			<div class="driver-info-body driver-info-body-tab-block" :class="{ 'show': (tab == 'circle') }">
				<div v-if="circle_list.length > 0">
					<div v-for="(circle, indexCircle) in circle_list" :key="indexCircle" class="driver-item" @click="onClick(circle.coordinates)">
						<div class="driver-info-item">
							<div class="driver-info-left">Centro da região</div>
							<div class="driver-info-right">{{ circle.coordinates }}</div>
						</div>
						<div class="driver-info-item">
							<div class="driver-info-left">Início</div>
							<div class="driver-info-right">{{ getDateAndHourFormated(circle.start) }}</div>
						</div>
						<div class="driver-info-item">
							<div class="driver-info-left">Fim</div>
							<div class="driver-info-right">{{ getDateAndHourFormated(circle.end) }}</div>
						</div>
						<div class="driver-info-item">
							<div class="driver-info-left">Tempo total</div>
							<div class="driver-info-right">{{ calcTime(circle.time) }}</div>
						</div>
					</div>
				</div>
				<div v-else>
					<div class="driver-item">
						<p class="text-center"><small><i>Não foram encontradas pausas nessas condições</i></small></p>
					</div>
				</div>
			</div>
		</div>
		<div class="control control-start" @click="onClickStart()" title="Início da rota">
			<i class="fas fa-fw fa-mobile-alt"></i>
		</div>
		<div class="control control-driver" @click="onClickDriver()" title="Última posição do motorista">
			<i class="fas fa-fw fa-truck"></i>
		</div>
		<div class="map" ref="map"></div>
	</div>
</template>

<script>
import GoogleMapsApiLoader from 'google-maps-api-loader';
import $ from "jquery";

const status = {
	waiting: {
		url: require("@/assets/yellow_marker2.svg"),
		color: "#ffb300",
		status: "Aguardando",
	},
	in_progress: {
		url: require("@/assets/blue_marker2.svg"),
		color: "#005ef7",
		status: "A caminho",
	},
	finished: {
		url: require("@/assets/green_marker2.svg"),
		color: "#008000",
		status: "Finalizado",
	},
	failed: {
		url: require("@/assets/red_marker2.svg"),
		color: "#ff0000",
		status: "Não entregue",
	},
	untracked: {
		url: require("@/assets/gray_light_marker3.svg"),
		color: "#aaa",
		status: "Desvinculado",
	},
};
export default {
	name: "RouteGoogleMaps",

	props: {
		driver: {
			type: Object,
			require: true,
		},
		deliveries: {
			type: Array,
			require: true,
		},
		positions: {
			type: Array,
			require: true,
		},
		settings: {
			type: Object,
			require: true,
		}
	},

	data: function() {
		return {
			google: null,
			map: null,
			center: {
				lat: this.driver.location.split(",")[0],
				lng: this.driver.location.split(",")[1],
			},
			zoom: 13,

			start_position: {
				lat: parseFloat(this.driver.location.split(",")[0]),
				lng: parseFloat(this.driver.location.split(",")[1]),
			},
			driver_position: {
				lat: parseFloat(this.driver.location.split(",")[0]),
				lng: parseFloat(this.driver.location.split(",")[1]),
			},

			circle_list: [],
			//circle_list_positions: [],

			tab: 'delivery',

			total_weight: 0.0,
			total_distance: 0.0,

			pause: this.settings.pause ? this.settings.pause.split(" ")[0] : "",
			radius: this.settings.radius ? this.settings.radius.split(" ")[0] : "",
		}
	},

	mounted: function() {
		this.start();
	},
	
	methods: {
		/**
		 * Inicia a API do Google
		 **/
        start: async function() {
			// Carrega a API do Google Map
			this.google = await GoogleMapsApiLoader({
				apiKey: this.$api.config.B2B_GOOLE_API_KEY
			});

			// Inicia a exibição do mapa
			this.initializeMap();
			this.createStartPositionMarker();
			this.createDriverPositionMarker();
			this.createDeliveryPositionMarkers();
			this.createCicle();
		},

		/**
		 * Gera o mapa com os marcadores no modal
		 **/
        initializeMap: async function() {
			// Cria o mapa
			let map = new this.google.maps.Map(this.$refs.map, {
				center: {
					lat: parseFloat(this.center.lat),
					lng: parseFloat(this.center.lng),
				},
				backgroundColor: "#fefefe",
				draggable: true,
				zoom: 13,
				zoomControl: true,
				zoomControlOptions: {
					position: this.google.maps.ControlPosition.RIGHT_BOTTOM,
				},
				streetViewControl: false,
				mapTypeControl: false,
				fullscreenControl: false,
				styles: [
					{
						featureType: "poi",
						stylers: [{
							visibility: "off",
						}],
					},{
						featureType: "transit",
						elementType: "labels.icon",
						stylers: [{
							visibility: "off",
						}],
					},
				],
			});

			// Define o objeto do mapa
            this.map = map;
        },
		
		/**
		 * Adiciona o marcador na posição inicial
		 **/
        createStartPositionMarker: function() {
			// Inicia as informações necessárias
			let dateHour = "";

            // Verifica se há posições e se a primeira tem as informações necessárias
			if ((typeof this.positions != "undefined") && (this.positions.length > 0) && (typeof this.positions[0].position != "undefined")) {
				this.start_position = {
					lat: parseFloat(this.positions[0].position.split(",")[0]),
					lng: parseFloat(this.positions[0].position.split(",")[1]),
				};

				// Obtém a date e hora
				dateHour = this.getDateAndHourFormated(this.positions[0].date).split(" ");
			} else {
				let dateHourAux = this.driver.updated_at.split("T");

				dateHour = this.getDateAndHourFormated(dateHourAux[0] + " " + dateHourAux[1].split(".")[0]).split(" ");
			}
				
			// Determina o marcador da posiçaõ do APP e coloca no mapa
			let marker = new this.google.maps.Marker({
				position: {
					lat: this.start_position.lat,
					lng: this.start_position.lng,
				},
				map: this.map,
				icon: {
					url: require("@/assets/start_marker2.svg"),
					size: new this.google.maps.Size(40, 40),
					scaledSize: new this.google.maps.Size(40, 40),
					origin: new this.google.maps.Point(0, 0),
					anchor: new this.google.maps.Point(20, 40),
					labelOrigin: new this.google.maps.Point(20, 50),
					draggable: false,
				},
				label: {
					text: "Início",
					fontWeight: "bold",
					color: "#005ef7",
					className: "marker-label",
				},
				zIndex: 8,
			});
			
			// Define as informações que aparecerão no popup
			let infowindow = new this.google.maps.InfoWindow({
				content: 
					'<div class="popup">' +
						'<h3><b>Registro de posição</b></h3>' +
						'<p class="marker"><b><i class="fa fa-fw fa-calendar-alt"></i> Data:</b> ' +  dateHour[0] + '</p>' +
						'<p class="marker"><b><i class="fa fa-fw fa-clock"></i> Hora:</b> ' +  dateHour[1] + '</p>' +
					'</div>',
				pixelOffet: new this.google.maps.Point(0, 0),
			});
			
			// abre o popup ao passar o mouse por cima do marcador
			this.google.maps.event.addListener(marker, "mouseover", function() {
				infowindow.open(this.map, marker);
			});

			// Fecha o popup ao retirar o mouse de cima do marcador
			this.google.maps.event.addListener(marker, "mouseout", function() {
				infowindow.close(this.map, marker);
			});
        },

		/**
		 * Adiciona o marcador ná última posição
		 **/
        createDriverPositionMarker: function() {
			// Inicia as informações necessárias
			let last_position = 0;
			let dateHour = "";

			// Verifica se há posições e se a última tem as informações necessárias
			if (this.positions && (this.positions.length > 0)) {
				last_position = this.positions.length - 1;
				if (typeof this.positions[last_position].position != "undefined") {
					this.driver_position = {
						lat: parseFloat(this.positions[last_position].position.split(",")[0]),
						lng: parseFloat(this.positions[last_position].position.split(",")[1]),
					};

					// Obtém a date e hora
					dateHour = this.getDateAndHourFormated(this.positions[last_position].date).split(" ");
				} else {
					let dateHourAux = this.driver.updated_at.split("T");
					dateHour = this.getDateAndHourFormated(dateHourAux[0] + " " + dateHourAux[1].split(".")[0]).split(" ");
				}
			} else {
				let dateHourAux = this.driver.updated_at.split("T");
				dateHour = this.getDateAndHourFormated(dateHourAux[0] + " " + dateHourAux[1].split(".")[0]).split(" ");
			}
				
			// Determina o marcador da posição do APP e coloca no mapa
			let marker = new this.google.maps.Marker({
				position: {
					lat: this.driver_position.lat,
					lng: this.driver_position.lng,
				},
				map: this.map,
				icon: {
					url: require("@/assets/truck_marker.svg"),
					size: new this.google.maps.Size(40, 40),
					scaledSize: new this.google.maps.Size(40, 40),
					origin: new this.google.maps.Point(0, 0),
					anchor: new this.google.maps.Point(20, 40),
					labelOrigin: new this.google.maps.Point(20, 50),
					draggable: false,
				},
				label: {
					text: this.driver.nickname ? this.driver.nickname : this.driver.driver_name.split(" ")[0],
					fontWeight: "bold",
					color: "#005ef7",
					className: "marker-label",
				},
				zIndex: 10,
			});
			
			// Define as informações que aparecerão no popup
			let infowindow = new this.google.maps.InfoWindow({
				content: 
					'<div class="popup">' +
						'<h3><b>Registro de posição</b></h3>' +
						'<p class="marker"><b><i class="fa fa-fw fa-calendar-alt"></i> Data:</b> ' +  dateHour[0] + '</p>' +
						'<p class="marker"><b><i class="fa fa-fw fa-clock"></i> Hora:</b> ' +  dateHour[1] + '</p>' +
					'</div>',
				pixelOffet: new this.google.maps.Point(0, 0),
			});
			
			// Abre o popup ao passar o mouse por cima do marcador
			this.google.maps.event.addListener(marker, "mouseover", function() {
				infowindow.open(this.map, marker);
			});

			// Fecha o popup ao retirar o mouse de cima do marcador
			this.google.maps.event.addListener(marker, "mouseout", function() {
				infowindow.close(this.map, marker);
			});

			// Centraliza da posiçao do marcador
			this.map.setCenter(new this.google.maps.LatLng(this.driver_position.lat, this.driver_position.lng));
        },

		/**
		 * Adiciona o marcador do ponto de entrega
		 **/
        createDeliveryPositionMarkers: function() {
			if (this.deliveries) {
				// Percorre a lista de entregas
				this.deliveries.forEach((delivery, index) => {
					// Adiciona a distância ao total
					this.total_weight += delivery.weight;

					// Verifica se é um registro que tem coordenada (novos registros)
					if(delivery.coordinates) {
						// Obtém as coordenadas
						let coordinates = {
							lat: delivery.coordinates.split(",")[0],
							lng: delivery.coordinates.split(",")[1],
						};

						// Determina o marcador da posiçaõ do APP e coloca no mapa
						let marker = new this.google.maps.Marker({
							position: {
								lat: parseFloat(coordinates.lat),
								lng: parseFloat(coordinates.lng)
							},
							map: this.map,
							icon: {
								url: status[delivery.status].url,
								size: new this.google.maps.Size(40, 40),
								scaledSize: new this.google.maps.Size(40, 40),
								origin: new this.google.maps.Point(0, 0),
								anchor: new this.google.maps.Point(20, 40),
								labelOrigin: new this.google.maps.Point(20, 17),
								draggable: false,
							},
							zIndex: 20,
						});
						
						if ((delivery.status != "waiting") && (delivery.status != "in_progress") && (delivery.status != "untracked") && (this.deliveries.length > 1)) {
							marker.setLabel({
								text: String(index + 1),
								fontWeight: "bold",
								color: status[delivery.status].color,
								className: "marker-label",
							});
						}

						// Define data e hora do início
						let dateHourAux = "";
						if(delivery.delivery_end) {
							dateHourAux = '<p class="marker"><b><i class="fa fa-fw fa-people-carry"></i> ' + (delivery.status != "failed" ? "Entrega" : "Tentativa de entrega") + ':</b> ' +  this.getDateAndHourFormated(delivery.delivery_end) + '</p>';
						}
						
						// Define as informações que aparecerão no popup
						let infowindow = new this.google.maps.InfoWindow({
							content:
								'<div class="popup">' +
									'<h3><b>Nº </b> ' +  delivery.document_number + '</h3>' +
									'<h3 class="capitalized"><b>' + delivery.customer_name.toLowerCase() + '</b></h3>' +
									'<h4><b><span style="color: ' + status[delivery.status].color + '"><i class="fa fa-circle"></i></span> ' + status[delivery.status].status + '</b></h4>' +
									'<p class="marker capitalized"><b><i class="fa fa-fw fa-file-signature"></i> Tipo:</b> ' + (delivery.type ? "Pedido" : "Nota Fiscal") + '</p>' +
									'<p class="marker"><b><i class="fa fa-fw fa-calendar-alt"></i> Data:</b> ' + this.getDateFormated(delivery.date) + '</p>' +
									'<p class="marker"><b><i class="fa fa-fw fa-boxes"></i> Carga:</b> ' + (delivery.cargo ? delivery.cargo : "Não definida") + '</p>' +
									'<p class="marker capitalized"><b><i class="fa fa-fw fa-map-marker-alt"></i> Endereço:</b> ' +  delivery.street.toLowerCase() + ", " + delivery.number.toLowerCase() + " - " + delivery.neighborhood.toLowerCase() + '</p>' +
									'<p class="marker capitalized"><b><i class="fa fa-fw fa-globe-americas"></i> Local:</b> ' +  delivery.city.toLowerCase() + ' - ' + delivery.uf.toUpperCase() + ', ' + delivery.postal_code.replace(/^(\d{5})(\d{3})/, "$1-$2") + '</p>' +
									dateHourAux +
								'</div>',
							pixelOffet: new this.google.maps.Point(0, 0),
						});
						
						// abre o popup ao passar o mouse por cima do marcador
						this.google.maps.event.addListener(marker, "mouseover", function() {
							infowindow.open(this.map, marker);
						});
						
						// Fecha o popup ao retirar o mouse de cima do marcador
						this.google.maps.event.addListener(marker, "mouseout", function() {
							infowindow.close(this.map, marker);
						});
					}
				});

				// Gera a rota
				this.createRoute();
			}
        },

		/**
		 * Gera a rota
		 */
		createRoute: async function() 
		{
			// Verifica se há posições registradas para essa entrega
			if(this.positions.length > 0) 
			{
				// Inicia a lista de posição
				var positions = [];
				
				// Percorre os dados
				this.positions.forEach(async (element, index) => {
					// Armazena a posição
					positions.push(element.position);

					// Inicia os arrays de posições
					let coordinates = {
						lat: element.position.split(",")[0],
						lng: element.position.split(",")[1],
					};

					// Determina o marcador da posição do APP e coloca no mapa
					let marker = new this.google.maps.Marker({
						position: {
							lat: parseFloat(coordinates.lat),
							lng: parseFloat(coordinates.lng),
						},
						map: this.map,
						icon: {
							url: require("@/assets/app_marker2.svg"),
							size: new this.google.maps.Size(10, 10),
							scaledSize: new this.google.maps.Size(6, 6),
							origin: new this.google.maps.Point(0, 0),
							anchor: new this.google.maps.Point(3, 3),
						},
						zIndex: 1,
					});
					
					// Define o horario
					let dateHour = this.getDateAndHourFormated(element.date).split(" ");
					
					// Define as informações que aparecerão no popup
					let infowindow = new this.google.maps.InfoWindow({
						content:
							'<div class="popup">' +
								'<h3><b>Registro de posição</b></h3>' +
								'<p class="marker"><b><i class="fa fa-fw fa-calendar-alt"></i> Data:</b> ' +  dateHour[0] + '</p>' +
								'<p class="marker"><b><i class="fa fa-fw fa-clock"></i> Hora:</b> ' +  dateHour[1] + '</p>' +
							'</div>',
						pixelOffet: new this.google.maps.Point(0, 0),
					});
					
					// abre o popup ao passar o mouse por cima do marcador
					this.google.maps.event.addListener(marker, "mouseover", function() {
						infowindow.open(this.map, marker);
					});
					
					// Fecha o popup ao retirar o mouse de cima do marcador
					this.google.maps.event.addListener(marker, "mouseout", function() {
						infowindow.close(this.map, marker);
					});

					// Calcula a distância para a próxima posição
					let distance = 0;
					if (typeof this.positions[index + 1] != "undefined")
					{
						// Identifica o ponto de saída
						let positionFrom = {
							lat: parseFloat(element.position.split(",")[0]),
							lng: parseFloat(element.position.split(",")[1]),
						};

						// Identifica o ponto de chegada
						let positionTo = {
							lat: parseFloat(this.positions[index + 1].position.split(",")[0]),
							lng: parseFloat(this.positions[index + 1].position.split(",")[1]),
						};

						// Obtém a distância entre esses pontos
						distance = this.calcDistance(positionFrom, positionTo);
					}
					
					// Verifica se o array de pontos tem 100 elementos
					// Ou se é a última posição registrada
					// Ou se a data da próxima posição é diferente da atual
					// Ou se tem distância maior que 1 km para próxima posição
					if (((positions.length % 100) == 0) || ((index + 1) == this.positions.length) || ((typeof this.positions[index + 1].date.split(" ")[0] != "undefined") && (element.date.split(" ")[0] != this.positions[index + 1].date.split(" ")[0])) || (distance > 1)) 
					{
						// Cria a linda dos pontos
						this.createRouteLine(positions);
						// Percorre os pontos
						for(let i = 0; i < positions.length; i++)
						{
							// Verifica se não é o próximo da
							if (typeof positions[i + 1] != "undefined") 
							{
								// Identifica o ponto de saída
								let positionFrom = {
									lat: parseFloat(positions[i].split(",")[0]),
									lng: parseFloat(positions[i].split(",")[1]),
								};

								// Identifica o ponto de chegada
								let positionTo = {
									lat: parseFloat(positions[i + 1].split(",")[0]),
									lng: parseFloat(positions[i + 1].split(",")[1]),
								};

								// Adiciona a distância ao total
								this.total_distance += this.calcDistance(positionFrom, positionTo);
							}
						}
						
						// Limpa a lista de posição
						positions.length = 0;
						
						// Verifica se não é o último ponto da lista
						// Ou se a data da próxima posição é igual ao atual
						// Ou se a distância para a próxima posição for menor que 1 km
						if ((((index + 1) == this.positions.length) || ((typeof this.positions[index + 1].date.split(" ")[0] != "undefined") && (this.positions[index].date.split(" ")[0] == this.positions[index + 1].date.split(" ")[0]))) && (distance < 1)) {
							// Adiciona o ponto ao próximo trecho
							positions.push(element.position);
						}
					}
				});
			}
		},
		
		/**
		 * Gera a linha
		 */
		createRouteLine: async function(positions) 
		{
			// Requisita a API do Google os pontos para a rota
			let result = null;
			try {
				result = await $.get("https://roads.googleapis.com/v1/snapToRoads", {
					interpolate: true,
					key: this.$api.config.B2B_GOOLE_API_KEY,
					path: positions.join('|'),
				});
			} catch (ex) {
				console.log(ex);
			}
			
			// Verifica se houve resultado
			if (result != null) 
			{
				let snappedCoordinates = [];
				// Verifica o resultado retornado da API
				if (typeof result.snappedPoints != "undefined") 
				{
					// Percorre os pontos retornado pela API do Goolgle
					for (var j = 0; j < result.snappedPoints.length; j++) 
					{
						var latlng = new this.google.maps.LatLng(
							result.snappedPoints[j].location.latitude,
							result.snappedPoints[j].location.longitude
						);
						snappedCoordinates.push(latlng);
					}
				}
				// Verifica se foi traçado uma reta
				if (typeof result.warningMessage != "undefined")
				{
					console.log(result.warningMessage);
				} else {
					// Cria a linha da rota no mapa
					let snappedPolyline = new this.google.maps.Polyline({
						path: snappedCoordinates,
						strokeColor: "#008000",
						strokeWeight: 4,
						strokeOpacity: .5,
						zIndex: 5,
					});
					
					// Adiciona o polyline ao mapa
					snappedPolyline.setMap(this.map);
				}
			}
		},

		/**
		 * Gera a marcação de região onde houve uma parada por determinado tempo
		 */
		createCicle: function() {
			// Verifica se há posições registradas para essa entrega
			if (this.positions && (this.positions.length > 0) && (this.pause != "")) {
				// Posição de centro da região
				let center = {
					position: null,
					date: null,
					datetime_start: null,
					datetime_end: null,
					time: 0,
				};
				
				// Percorre as posições
				this.positions.forEach((element, index) => {
					// Inicia o objeto da posição
					let element_position = {
						lat: element.position.split(",")[0],
						lng: element.position.split(",")[1],
					};

					// Verifica a posição do centro
					if (center.position != null) {
						// Verifica se a distância entre o centro e a posição atual está dentro da área do raio
						// Verifica se a data é diferente
						if ((this.calcDistance(center.position, element_position) <= ((this.radius ? this.radius : 300) / 1000)) && (center.date != element.date)) {
							// Define as informações de data e tempo da posição atual
							let element_datetime = new Date(element.date.replace(/-/g, "/"));
							
							// Atualiza a data e tempo final da região
							center.datetime_end = element_datetime;
							
							// Verifica se é a última posição
							if (index + 1 == this.positions.length) {
								// Cria a região no mapa
								this.createCircleRegion(center, element.date);
							}
						} else {
							// Cria a região no mapa
							this.createCircleRegion(center, element.date);
							
							// Atualiza o centro
							center = this.setCenter(element);
						}
						
						/*// Verifica se o registro atual tem a mesma podição
						if ((element.position == center.position) && (this.positions[index + 1].position != center.position)) {
							// Verifica se a data é diferente e se o próximo tem posição diferente
							if (element.date != center.date) {
								// Define as informações de data e tempo do registro atual
								let element_datetime = new Date(element.date.replace(/-/g, "/"));
								
								// Tira a diferença de tempo entre início e fim
								let diff = element_datetime.getTime() - center.datetime.getTime();

								// Verifica o tempo
								if (diff > parseInt(this.calcPause(this.pause))) {
									// Verifica se não está dentro do raio de posições já definidas
									//if (!this.verifyCircleListRadius(coordinates)) {
										let circle = new this.google.maps.Circle({
											strokeColor: "#ff0000",
											strokeOpacity: 0.35,
											strokeWeight: 2,
											fillColor: "#ff0000",
											fillOpacity: 0.35,
											map: this.map,
											center: {
												lat: parseFloat(coordinates.lat),
												lng: parseFloat(coordinates.lng)
											},
											radius: this.radius ? parseInt(this.radius) : 300,
										});
										
										circle.start = center.date;
										circle.end = element.date;
										circle.time = diff;
										circle.coordinates = center.position;
										this.circle_list.push(circle);
									//}
								}
							}
						} else {
							// Atualiza o centro
							center = this.setCenter(element);
						}*/
					} else {
						// Define o centro
						center = this.setCenter(element);
					}
				});
			}
		},
		
		// Define o centro da região
		setCenter: function(element) {
			// Inicia o centro
			let center = {
				position: null,
				date: null,
				datetime_start: null,
				datetime_end: null,
				time: 0,
			};

			// Registra o centro
			center.date = element.date;
			center.time = 0;

			// Define o objeto de posição
			let position = {
				lat: element.position.split(",")[0],
				lng: element.position.split(",")[1],
			};
			center.position = position;

			// Define as informações de data e tempo do centro
			let center_datetime = new Date(center.date.replace(/-/g,"/"));
			center.datetime_start = center_datetime;
			center.datetime_end = center_datetime;

			return center;
		},

		createCircleRegion: function(center, date_end) {
			// Tira a diferença de tempo entre início e fim
			let diff = center.datetime_end.getTime() - center.datetime_start.getTime();

			// Verifica o tempo
			if (diff > parseInt(this.calcPause(this.pause))) {
				// Cria a marcação da região de parada
				let circle = new this.google.maps.Circle({
					strokeColor: "#ff0000",
					strokeOpacity: 0.35,
					strokeWeight: 2,
					fillColor: "#ff0000",
					fillOpacity: 0.35,
					map: this.map,
					center: {
						lat: parseFloat(center.position.lat),
						lng: parseFloat(center.position.lng)
					},
					radius: this.radius ? parseInt(this.radius) : 300,
				});
					
				circle.start = center.date;
				circle.end = date_end;
				circle.time = diff;
				circle.position = center.position;
				circle.coordinates = center.position.lat + "," + center.position.lng;
				this.circle_list.push(circle);
			}
		},

		showMessage: function() {
			if (this.pause != "") {
				if (this.circle_list.length > 0) {
					this.$notification.success("Foram encontradas " + this.circle_list.length + " regiões nessas condições.");
				} else {
					this.$notification.error("Não foram encontradas regiões nessas condições");
				}
			}
		},

		// Calcula a longitude e latitude de dois pontos e retorna a distânca em km
		calcDistance: function(positionFrom, positionTo) 
		{
			const R = 6371; // km
			let dLat = this.toRad(positionTo.lat - positionFrom.lat);
			let dLng = this.toRad(positionTo.lng - positionFrom.lng);
			let latFrom = this.toRad(positionFrom.lat);
			let latTo = this.toRad(positionTo.lat);

			let a = Math.sin(dLat/2) * Math.sin(dLat/2) + Math.sin(dLng/2) * Math.sin(dLng/2) * Math.cos(latFrom) * Math.cos(latTo); 
			let c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a)); 
			let d = R * c;
			return d;
		},

		// Converte grau para radiano
		toRad: function(value) 
		{
			return value * Math.PI / 180;
		},
		
		// Retorna o status do pedido
		getStatus: function(current_status) 
		{
			return status[current_status].status;
		},
		
		// Retorna a cor do status do pedido
		getStatusColor: function(current_status) 
		{
			return status[current_status].color;
		},

		// Retorna a data formatada
		getDateFormated: function(date) 
		{
			return date.split("-").reverse().join("/");
		},
		
		// Retorna a data e horário formatados
		getDateAndHourFormated: function(data) 
		{
			let date = new Date(data);
			return date.toLocaleString();
		},
		
		// Atualiza o centro do mapa
		onClick: function(position) 
		{
			// Determina a coordenada
			let coordinates = {
				lat: parseFloat(position.split(",")[0]),
				lng: parseFloat(position.split(",")[1]),
			};

			// Centraliza o mapa
			this.map.setCenter(new this.google.maps.LatLng(coordinates.lat, coordinates.lng));

			// Define o zoom do mapa
			this.map.setZoom(16);
		},
		
		// Atualiza o centro do mapa para a posição do motorista
		onClickStart: function() 
		{
			// Centraliza o mapa
			this.map.setCenter(new this.google.maps.LatLng(this.start_position.lat, this.start_position.lng));

			// Define o zoom do mapa
			this.map.setZoom(16);
		},

		// Atualiza o centro do mapa para a posição do motorista
		onClickDriver: function() 
		{
			// Centraliza o mapa
			this.map.setCenter(new this.google.maps.LatLng(this.driver_position.lat, this.driver_position.lng));

			// Define o zoom do mapa
			this.map.setZoom(16);
		},
		
		// Verifica se uma posição está dentro do raio de um círculo
		verifyCircleListRadius: function(value) {
			let result = false;
			//this.circle_list_positions.forEach(position => {
			this.circle_list.forEach(circle => {
				//let distance = this.calcDistance(position, value);
				let distance = this.calcDistance(circle.coordinates, value);
				if (distance <= 0.15) {
					result = true;
				}
			});
			return result;
		},
		
		// Remove as marcações de círculo do mapa
		circleRemove: function() {
			this.circle_list.forEach(element => {
				element.setMap(null);
			});
			this.circle_list.length = 0;
			//this.circle_list_positions.length = 0;
		},

		// Remove as marcações de círculo do mapa
		updateRadius: function() {
			this.circle_list.forEach(element => {
				element.setRadius(this.radius ? parseInt(this.radius) : 300);
			});
		},

		// Limpar o campo de pesquisa
        inputPauseClean: function() {
            this.pause = "";
            this.circleRemove();
			this.createCicle();
        },

		/**
         * Retorna o peso
         * @param {number} weight peso em quilos
         * @return {string} peso em quilos ou toneladas
         */
		getWeight: function(weight) {
            let weightFormated = "";
			
            if(weight < 1000)
                weightFormated = weight.toFixed(2) + " kg";
            else
                weightFormated = (weight / 1000).toFixed(2) + " t";
            
            return weightFormated.replace(".", ",");
        },

		calcTime: function(time) {
			let seconds = Math.floor((time / 1000) % 60),
				minutes = Math.floor((time / (1000 * 60)) % 60),
				hours = Math.floor((time / (1000 * 60 * 60)) % 24);

			hours = (hours < 10) ? "0" + hours : hours;
			minutes = (minutes < 10) ? "0" + minutes : minutes;
			seconds = (seconds < 10) ? "0" + seconds : seconds;

			return hours + ":" + minutes + ":" + seconds;
		},

		calcPause: function(value) {
			return parseInt(value) * 60000;
		},

		updatePause: function() {
			if (parseInt(this.pause) >= 10) {
				this.circleRemove();
				this.createCicle();
			} else {
				this.$notification.error("O tempo de permanência na localidade deve ser maior ou igual a 10 minutos.");
			}
		},
	}
}
</script>

<style scoped>
.map {
	position: static;
    width: 100%;
	height: calc(100vh - 112px);
    border: none;
	z-index: 1;
}

.control {
	position: absolute;
	box-shadow: 0 2px 1px -1px rgba(0,0,0,.2),0 1px 1px 0 rgba(0,0,0,.14),0 1px 3px 0 rgba(0,0,0,.12) !important;
	padding: 10px;
	background-color: #fff;
	color: #666;
	z-index: 3;
	border-radius: 2px;
	cursor: pointer;
}

.control-start {
	position: fixed;
	top: 95px;
	right: 45px;
}

.control-driver {
	position: fixed;
	top: 135px;
	right: 45px;
}

.driver-info {
    position: fixed;
	top: 95px;
	margin-left: 10px;
    width: 370px;
	background: #fff;
	border-radius: 4px;
	z-index: 3;
}

.driver-info-head {
    width: 100%;
    overflow: hidden;
	border-top-left-radius: 4px;
	border-top-right-radius: 4px;
	border-bottom: 1px solid #cdcdcd;
	background-color: #eee;
	padding: 10px;
	font-weight: bold;
}

.driver-info-name {
	padding-bottom: 5px;
	text-align: center;
	font-size: 14px;
	border-bottom: 1px solid #cdcdcd;
}

.driver-info-summary {
	text-align: center;
	font-size: 12px;
}

.driver-info-summary-icon {
	font-size: 20px;
	margin-top: 10px;
	margin-bottom: 10px;
}

.driver-info-form {
    width: 100%;
    overflow: hidden;
	background-color: #eee;
	padding: 15px;
    border-bottom: 1px solid #cdcdcd;
}

.select-label {
    position: absolute;
    font-size: 13px;
    margin-top: 8px;
    margin-left: 5px;
}

.select {
    width: 100%;
    height: 30px;
}

select.select-pause {
    padding-left: 20px;
    background-color: #fff;
    border: 1px solid #8f8f9d;
}

.input-label {
    position: absolute;
    font-size: 13px;
    margin-top: 8px;
    margin-left: 5px;
	color: #FF0000;
}

.input-clean {
    position: absolute;
    font-size: 15px;
    margin-top: 0px;
    margin-left: -22px;
    height: 30px;
    background-color: transparent;
    border: none;
}

.filter {
    width: 100%;
    height: 30px;
}

.input-pause-label {
	line-height: 30px;
	font-size: 12px;
	padding-right: 0px;
}

.input-pause-div {
	padding-left: 0px;
}

input.input-pause {
    padding-left: 20px;
    padding-right: 20px;
}

input.input-pause::placeholder {
    color: #191919;
}

.input-pause-sufix {
	padding-left: 0px;
	font-size: 14px;
	line-height: 30px;
}

.input-pause-button {
	float: right;
	margin: 0;
}

.driver-info-list {
    border-bottom: 1px solid #eee;
}

.driver-info-body-tab {
	background: #eee;
	border: 1px solid #eee;
	border-bottom: none;
	padding: 10px 15px;
	margin-right: 5px;
	font-weight: bold;
    margin-bottom: -1px;
}

.driver-info-body-tab.enabled {
	background: #fff;
}

.driver-info-body-tab-block {
	display: none;
}

.driver-info-body-tab-block.show {
	display: block;
}

.driver-info-body {
	float: left;
    width: 100%;
	border-bottom-left-radius: 4px;
	border-bottom-right-radius: 4px;
	overflow-y: auto;
	max-height: calc(100vh - 360px);
	background-color: #cdcdcd;
}

.driver-info-item {
	position: relative;
    padding: 10px 15px;
    float: left;
    width: 100%;
    border-bottom: 1px solid #f5f5f5;
}

.driver-info-item.driver-info-item-name,
.driver-info-item.driver-info-item-license-plate,
.driver-info-item.driver-info-item-cargo {
	padding: 5px 0px;
	border-bottom: none;
}

.driver-info-item.driver-info-item-name {
	font-size: 14px;
	text-align: center;
}

.driver-info-left {
    width: 50%;
    float: left;
    font-size: 12px;
    font-weight: bold;
	display: grid;
    align-content: center;
}

.driver-info-right {
    width: 50%;
    float: right;
    text-align: right;
    font-size: 12px;
}

.driver-item {
	width: 100%;
	float: left;
	margin-bottom: 15px;
	background-color: #fff;
	cursor: pointer;
}

.driver-item:last-child {
	margin-bottom: 0px;
}

.driver-info-body-tab-block.show {
	display: block;
}

.text-center {
	text-align: center;
}

.button-edit {
	width: 100%;
}
</style>